import { combineReducers } from "redux"

import walletReducer from "./wallet"
import smsBalanceReducer from "./smsBalance"
import userAccountInfoReducer from "./userAccountInfo"
import systemSettingsReducer from "./systemSettings"
import notViewedOrdersReducer from "./notViewedOrders"
import contractDeactivationStatusReducer from "./contractDeactivationStatus"

export default combineReducers({
  userAccountInfo: userAccountInfoReducer,
  systemSettings: systemSettingsReducer,
  wallet: walletReducer,
  smsBalance: smsBalanceReducer,
  notViewedOrders: notViewedOrdersReducer,
  contractDeactivationStatus: contractDeactivationStatusReducer
})